import {
  faComment,
  faLightbulbOn,
  faPlusCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { MuiTheme as theme } from 'Common/theme';
import { faBug, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

export const colorForGroup: ColorForGroup = {
  comment: theme.palette.success.main,
  suggestion: theme.palette.secondary.main,
  issue: theme.palette.warning.main,
  uncategorized: theme.palette.grey[700],
};

export const iconForGroup: IconForGroup = {
  comment: faComment,
  suggestion: faLightbulbOn,
  issue: faBug,
  uncategorized: faPlusCircle,
};

export type ColorForGroup = {
  [group: string]: string;
};

export type IconForGroup = {
  [group: string]: IconDefinition;
};

export type CategoryLabel = 'issue' | 'suggestion' | 'comment';
export type CategoryGroupLabel = CategoryLabel | 'uncategorized';

export type CommentCategoryDetails = {
  name: string;
  description?: string;
  color?: string;
  label?: string;
  default_severity?: number;
  hide_severity?: boolean;
};
export type CommentCategoryGroup = {
  [key: string]: CommentCategoryDetails;
};
export type CommentCategories = {
  [key: string]: CommentCategoryGroup;
};

export interface CategoryGroup {
  label: string;
  color: string;
  icon?: IconDefinition;
  options: CategoryOption[];
}

export type CategoryOptions = {
  [key: string]: CategoryOption;
};

export interface CategoryOption {
  value: string;
  label: string;
  color: string;
}
